export default {
  page_home: {
    mock_tit: "Social Science Thesis Exam",
  },
};
